import type { AuthRepositoryPort } from "../ports/auth.repository.port";

export function forgotPasswordUseCase(repository: AuthRepositoryPort, email: string) {
  return repository.forgotPassword(email);
}
